import React, {useEffect, useState} from 'react';
import {Link, Navigate} from 'react-router-dom';
import decodeToken from '../../../../utils/decode-token';
import {useTranslation} from 'react-i18next';
import SafeHtml from '../../../atoms/safe-html';
import apiClient from '../../../../utils/apiClient';
import CatalogHero from '../../../../assets/img/product-catalog/catalog-hero.mp4';
import CatalogVideo from '../../../../assets/img/product-catalog/catalog-video.mp4';
import Carrusel1 from '../../../../assets/img/product-catalog/carrusel1.jpg';
import Carrusel2 from '../../../../assets/img/product-catalog/carrusel2.jpg';
import Carrusel3 from '../../../../assets/img/product-catalog/carrusel3.jpg';
import content_image_1 from '../../../../assets/img/product-catalog/p1.jpg';
import content_image_2 from '../../../../assets/img/product-catalog/p2.jpg';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ModalHacShowContact from "../../role-hac/modal-hac-show-contact/modal-hac-show-contact";
import Wadsworth from "../../role-hac/wadsworth/wadsworth";
import MediaTextBlock from '../media-text-block';

const ProductCatalog = () => {
  window.scroll(0, 0);
  const {t} = useTranslation();

  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token)?.role;

  const [, setLinkRole] = useState(null);

  const [catalogItems, setCatalogItems] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  const carrousel = [
    {image: Carrusel1, priority: 1},
    {image: Carrusel2, priority: 2},
    {image: Carrusel3, priority: 3},
  ];
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: false,
  };

  useEffect(() => {
    // Asignar el rol para el enlace
    switch (role) {
      case 'hac':
        setLinkRole('hac');
        break;
      case 'pma':
      case 'pmaGM':
        setLinkRole('pma');
        break;
      case 'retailer':
      case 'retailerGM':
        setLinkRole('hac');
        break;
      case 'admin':
      case 'marketAdmin':
      case 'countryAdmin':
        setLinkRole('admin');
        break;
      default:
        setLinkRole(null);
    }
  }, [role]);

  const showContact = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    // Obtener los datos de la API
    const fetchCatalog = async () => {
      try {

        const token = sessionStorage.getItem('token') || null;

        if (!token) {
          console.error('No se encontró ningún token en sessionStorage.');
          return;
        }

        const basicInfoUrl = `${process.env.REACT_APP_API_URL}/cms/product-catalog`;

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await apiClient.get(basicInfoUrl, config);

        const sorted = response.data.sort((a, b) => a.priority - b.priority);

        setCatalogItems(sorted);
      } catch (error) {
        console.error('Error fetching catalog data:', error);
      }
    };

    fetchCatalog();
  }, []);

  if (!token) return <Navigate to="/login"/>;

  return (
    <>
      {role === 'hac' && (
        <div style={{ display: 'none' }}>
          <Wadsworth />
        </div>
      )}
      <section className="hero video">
        <div>
          <video
            autoPlay
            muted
            playsInline
            controls
            style={{width: '100%'}}
          >
            <source src={CatalogHero} type="video/mp4"/>
            Your browser does not support the video tag.
          </video>
          <h1>
            {t('bespoke-headline')}
            <small>{t('bespoke-subheadline')}</small>
          </h1>
        </div>
      </section>
      <section>
        <div className="inner">
          <div className="past-experiences">
            <section>

                <h2>{t('limitededition-catalog-headline')}</h2>
                <p>{t('limitededition-catalog-introduction')}</p>

                <div className="past-experiences">
                  <Slider
                    dots
                    infinite={false}
                    speed={500}
                    slidesToShow={3}
                    slidesToScroll={3}
                    arrows
                    responsive={[
                      { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                      { breakpoint: 992,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
                      { breakpoint: 600,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
                    ]}
                  >
                    {catalogItems.map((item) => (
                      <div key={item.item_id}>
                        <div className="card">
                          <img src={item.catalog_thumbnail_image} alt={item.catalog_title} />
                          <div className="card-body">
                            <strong>{item.catalog_title}</strong>
                            {/* evita <p> dentro de <p> */}
                            <SafeHtml as="p" html={item.catalog_body} />
                            <p>
                              <Link
                                to={`/hac/limited-edition`}
                                state={{ id: item.item_id }}
                                className="link"
                              >
                                <span className="icon-chevron-right"></span> {t('experiences-catalog-cta')}
                              </Link>
                            </p>

                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>

            </section>

          </div>
        </div>
      </section>

      <section className="dark">
        <div className="inner">
          <h2>{t('bespoke-block1-headline')}</h2>
          <p>{t('bespoke-block1-text')}</p>
          <section className="slider">

            <Slider {...sliderSettings}>
              {[...carrousel]
                .sort((a, b) => a.priority - b.priority)
                .map((item, idx) => (
                  <div key={idx}>
                    <img src={item.image} alt={`slide-${idx}`}/>
                  </div>
                ))}
            </Slider>

          </section>
          <br/>
          <br/>
          <br/>

        </div>
      </section>
      <section className="info">
        <div className="inner">
          <MediaTextBlock
            image={content_image_1}
            textHtml={t('bespoke-block2-text')}
            title={t('bespoke-block2-headline')}
          />
        </div>
      </section>
      <section className="dark">
        <div className="inner">
          <h2>{t('bespoke-block3-headline')}</h2>
          <p>{t('bespoke-block3-text')}</p>
          <video
            playsInline
            controls
            style={{width: '100%'}}
          >
            <source src={CatalogVideo} type="video/mp4"/>
            Your browser does not support the video tag.
          </video>
        </div>
      </section>
      <section className="info">
        <div className="inner">
          <MediaTextBlock
            image={content_image_2}
            imagePosition="end"
            textHtml={t('bespoke-block4-text')}
            title={t('bespoke-block4-headline')}
          />
        </div>
      </section>
      <section className="dark padded">
        <div className="inner contact">
          <h2>{t('bespoke-ending-headline')}</h2>
          <p>{t('bespoke-ending-text')}</p>
          <p>
            <button className="btn fit secondary" onClick={showContact}>
              {t('limitededition-footer-action')}
            </button>
          </p>
        </div>
      </section>
      <ModalHacShowContact
        open={openModal}
        handleClose={handleCloseModal}
        className="modal-contact"
      />
    </>
  );
};

export default ProductCatalog;
